import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

function formatDate(input: string | number): string {
  const date = new Date(input)
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  })
}

function absoluteUrl(path: string) {
  return `${process.env.NEXT_PUBLIC_APP_URL}${path}`
}

/**
 * Prevent double-encoding strings by first checking if it's already encoded.
 */
export function safeEncode(param: string): string {
  if (decodeURIComponent(param) !== param) {
    return param // Already encoded, return as is
  }
  return encodeURIComponent(param)
}

interface TextSizeParams {
  minFontSize: number
  maxFontSize: number
}

/**
 * Calculates font size based on text length
 * @param text The input text to size
 * @param params Configuration parameters for font size bounds
 * @returns Calculated font size in pixels
 */
export function calculateTextSize(
  text: string,
  params: TextSizeParams
): number {
  const { minFontSize, maxFontSize } = params

  // Calculate size ratio based on text length
  // Longer text = smaller ratio = smaller font
  const sizeRatio = Math.exp(-0.02 * text.length)

  // Linear interpolation between min and max font sizes
  const fontSize = minFontSize + sizeRatio * (maxFontSize - minFontSize)

  // Round to nearest decimal to avoid floating point issues
  return Math.round(fontSize * 10) / 10
}
